import { i18n } from "translations";
import { getMapObjectFromArray } from "utils";

import { EmployeeRewardDisciplineType } from "./types";

export const EmployeeRewardDisciplineTypeOptions = [
  {
    label: i18n.t("reward"),
    value: EmployeeRewardDisciplineType.Reward,
  },
  {
    label: i18n.t("discipline"),
    value: EmployeeRewardDisciplineType.Discipline,
  },
];

export const EmployeeRewardDisciplineTypeMap = getMapObjectFromArray(
  EmployeeRewardDisciplineTypeOptions
);
